// extracted by mini-css-extract-plugin
export default {"compareButton":"CompareButton_compareButton__B9iw3","icon":"CompareButton_icon__Rf+zK","counter":"CompareButton_counter__CBf2i","compareText":"CompareButton_compareText__r-CuA"};